import { Pipe, PipeTransform } from '@angular/core';

import { getLabelKebabCase } from './metric-selector-modal-pipes-utils';

/**
 * Create a unique string to identify the first element in a category's metric.
 * This is used to scroll to the top of each category's metrics.
 *
 * Value:
 *   metricByCategoryListId: The string identifying which component extending MetricByCategoryListDirective includes
 *     the item to scroll to. This is necessary because more than one of those components can exist on the same page.
 *
 * Params:
 *   categoryLabel: The label of the category this is the broadest way metrics are grouped.
 *
 */
@Pipe({
    name: 'getCategoryScrollId',
    standalone: false,
})
export class GetCategoryScrollIdPipe implements PipeTransform {
    transform(metricByCategoryListId: string, categoryLabel: string): string {
        return getLabelKebabCase([categoryLabel, metricByCategoryListId]);
    }
}
